const rasterLinks = {
  details: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/raster/${namespace}/${groupId}`,

  overview: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/raster/${namespace}/${groupId}/overview`,

  sharing: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/raster/${namespace}/${groupId}/sharing`,

  settings: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/raster/${namespace}/${groupId}/settings`,

  contents: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/raster/${namespace}/${groupId}/contents`,

  preview: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/raster/${namespace}/${groupId}/preview`,

  metadata: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/raster/${namespace}/${groupId}/metadata`,

  activity: ({ namespace, groupId }: { namespace: string; groupId: string }) =>
    `/raster/${namespace}/${groupId}/activity`,
};

export default rasterLinks;
